module.exports = __webpack_public_path__ + "assets/pdf/I03-cn-air-quality.a50429e9.pdf";